"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[70771],{

/***/ 170771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductHeader": function() { return /* binding */ ProductHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(212951);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(534924);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(723357);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  font-size: 24px;\n  line-height: 1.33;\n  margin-bottom: 8px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  ::before {\n    content: '|';\n    margin: 0 8px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





const ProductBrand = (param)=>{
    let { brandCode , brandName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CustomLink */ .x, {
        href: {
            pathname: "/brands/[brandId]",
            query: {
                brandId: brandCode
            }
        },
        as: {
            pathname: "/".concat(brandCode, "-brand.").concat(brandCode)
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Brand, {
            children: brandName
        })
    });
};
const ProductHeader = ()=>{
    var ref;
    const { product  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useProductDetailState */ .W)();
    const { isDisplayUom  } = (0,contexts__WEBPACK_IMPORTED_MODULE_4__/* .useGlobalData */ .U5)();
    const { flags  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useFeatureFlags */ .g)();
    const brandCode = product === null || product === void 0 ? void 0 : (ref = product.brand) === null || ref === void 0 ? void 0 : ref.code;
    const renderBrand = ()=>{
        var ref, ref1, ref2;
        const brands = (product === null || product === void 0 ? void 0 : product.brands) || [];
        if (flags.epic_omni_1552 && brands.length > 0) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: brands.map((brand, index)=>{
                    var ref;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBrand, {
                                brandCode: brand.code,
                                brandName: brand.name
                            }, "".concat(brand.code).concat(brand.name).concat(index)),
                            index + 1 !== (product === null || product === void 0 ? void 0 : (ref = product.brands) === null || ref === void 0 ? void 0 : ref.length) && ",\xa0"
                        ]
                    });
                })
            });
        }
        if (!brandCode || brandCode === "no-brand") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Brand, {
            children: product === null || product === void 0 ? void 0 : (ref = product.brand) === null || ref === void 0 ? void 0 : ref.name
        });
        return brandCode && (product === null || product === void 0 ? void 0 : (ref1 = product.brand) === null || ref1 === void 0 ? void 0 : ref1.name) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductBrand, {
            brandCode: brandCode,
            brandName: product === null || product === void 0 ? void 0 : (ref2 = product.brand) === null || ref2 === void 0 ? void 0 : ref2.name
        }) : null;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Title, {
                children: (product === null || product === void 0 ? void 0 : product.displayName) || (product === null || product === void 0 ? void 0 : product.name)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Caption */ .YS, {
                    level: 1,
                    weight: "regular",
                    color: "textSecondary",
                    style: {
                        fontSize: "14px",
                        marginTop: "-4px",
                        lineHeight: "1.25rem"
                    },
                    children: [
                        (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Thương hiệu"),
                        "\xa0",
                        " ",
                        renderBrand(),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Divider, {}),
                        " SKU: ",
                        (product === null || product === void 0 ? void 0 : product.sellerSku) || (product === null || product === void 0 ? void 0 : product.sku)
                    ]
                })
            }),
            isDisplayUom && !!(product === null || product === void 0 ? void 0 : product.uomName) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Caption */ .YS, {
                level: 1,
                weight: "regular",
                color: "textSecondary",
                style: {
                    fontSize: "14px",
                    margin: "16px 0"
                },
                children: [
                    (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đơn vị t\xednh"),
                    ": ",
                    product.uomName
                ]
            }) : null
        ]
    });
};
const Title = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].h1(_templateObject());
const Divider = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].span(_templateObject1());
const Brand = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__["default"].span((param)=>{
    let { theme  } = param;
    return "\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, ";\n  &:hover{\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary700, ";\n  }\n  ");
});


/***/ })

}]);